import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import { z } from "zod";

export const ResetPasswordTokenSchema = z.object({
  email:z.string().email()
}) 

export type ResetPasswordTokenSchemaType = z.infer<typeof ResetPasswordTokenSchema>;

export async function getResetPasswordToken(data: ResetPasswordTokenSchemaType) {
  return axiosInstance
    .post(`${config.apiUrl}/auth/reset-password-token`, {
      ...data,
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
}
